/**
 *
 * Get specific Url mapping
 * @param {UrlMappings} urlMappings - An object with key as type (default 'main') and array of Url Mapping as value
 * @param {String} key - A unique string that represent the url mapping entity, a page identifier for example 'wix.stores.sub_pages.product' for product page, 'pageId' for dynamic pages, etc...
 * @return {UrlMapping} urlMapping - The main URL mapping entity
 * @example <caption>Usage of the method</caption>
 *
 *
 * const urlMapping = {
 *       key: 'wix.stores.sub_pages.product',
 *       mapping: 'some-prefix/{{product-name}}',
 *       pageIdentifier: 'product-page',
 *       pageIdentifierType: PageIdentifierType.tpaPageId
 * }
 *
 * const urlMappings = {
 *  main: [urlMapping]
 * }
 *
 * getUrlMapping(urlMappings, 'com.wix.id');
 * // returns urlMapping
 *
 *
 **/
export var getUrlMapping = function (urlMappings, key) {
    var _a, _b;
    if (key === void 0) { key = ''; }
    return (_b = (_a = urlMappings === null || urlMappings === void 0 ? void 0 : urlMappings.main) === null || _a === void 0 ? void 0 : _a.find) === null || _b === void 0 ? void 0 : _b.call(_a, function (urlMapping) { return urlMapping.key === key; });
};
//# sourceMappingURL=get-url-mapping.js.map